exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".internshipsBox{border:3px solid #000;padding:30px;margin-bottom:30px}@media (max-width:29.99em){.internshipsBox{padding:20px}}", ""]);
